/**
 * @generated SignedSource<<9dee0493f23ad2f62b6b1c67afb143a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type FlightProvider = "KIWI" | "WAAVO";
import { FragmentRefs } from "relay-runtime";
export type FlightListProvider_flight$data = {
  readonly provider: FlightProvider;
  readonly " $fragmentType": "FlightListProvider_flight";
};
export type FlightListProvider_flight$key = {
  readonly " $data"?: FlightListProvider_flight$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightListProvider_flight">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightListProvider_flight",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "provider",
      "storageKey": null
    }
  ],
  "type": "Flight",
  "abstractKey": null
};

(node as any).hash = "25255034ce4cd606db2501e24bdca5b4";

export default node;
